<template>
  <div class="page-not-found">
    <div class="logo">
      <img src="@/assets/logos/s3_logo.png" width="180" />
    </div>
    <div class="content">
      <h1 class="content__title">{{ "Se pare că ai găsit o fundătură!" }}</h1>
      <p class="content__subtitle">
        {{
          "Din păcate, pagina pe care încerci să o accesezi a fost mutată sau nu există"
        }}
      </p>
      <p class="content__description">
        {{ "În 5 secunde vei fi redirecționat către prima pagină." }}
      </p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {
    this.redirectHome();
  },
  methods: {
    redirectHome() {
      setTimeout(() => {
        this.$router.push("/");
      }, 5000);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@storefront-ui/shared/styles/helpers/breakpoints";

.page-not-found {
  min-height: calc(100vh);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  @include for-mobile {
    padding: 0 var(--spacer-sm);
  }

  .content {
    &__title {
      margin: var(--spacer-sm) 0 0;
      font-family: var(--font-family-primary);
      font-size: 3rem;

      @include for-mobile {
        font-size: 2.5rem;
        line-height: 1.2;
      }
    }
    &__subtitle {
      font-family: var(--font-family-secondary);
      font-weight: var(--font-semibold);
      font-size: var(--font-sm);
      margin: var(--spacer-sm) 0 0;
    }
    &__description {
      font-size: var(--font-sm);
      margin: var(--spacer-2xl) 0 0;

      @include for-mobile {
        margin: var(--spacer-xl) 0 0;
      }
    }
  }
}
</style>
